import { render, staticRenderFns } from "./BackSlidePage.vue?vue&type=template&id=135f7294&scoped=true&lang=pug"
import script from "./BackSlidePage.vue?vue&type=script&lang=js"
export * from "./BackSlidePage.vue?vue&type=script&lang=js"
import style0 from "./BackSlidePage.vue?vue&type=style&index=0&id=135f7294&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135f7294",
  null
  
)

export default component.exports